/* eslint-disable no-console */
import {DenialLetterOdontoParams} from 'domain/usecases/private/authorizations-odonto/get-denial-letter-odonto';
import {makeGetDenialLetterOdonto} from 'main/factories/usecases/private/authorizations-odonto/get-denial-letter-odonto-factory';

export const getDenialLetterOdonto = async (params: DenialLetterOdontoParams) => {
	const denialLetterResponse = await makeGetDenialLetterOdonto().get(params);

	if (!(denialLetterResponse.denialLetter instanceof Blob)) {
		console.error('O retorno não é um Blob válido.');
	}

	return denialLetterResponse.denialLetter;
};
